var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationPresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M39 69h2V51h-2zM57 69h-2v-.829l-5.943-16.838 1.886-.666L57 67.829V69M25 69h-2v-1.171l.057-.162 6-17 1.886.666L25 68.171V69",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M68 52H12V22h2v28h52V22h2v30M10 18h60v-2H46.382l-2-4h-8.764l-2 4H10v2zm62 2H8v-6h24.382l2-4h11.236l2 4H72v6z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 31.083A6.01 6.01 0 0021 37c0 3.309 2.691 6 6 6a6.01 6.01 0 005.917-5H26v-6.917zM27 45c-4.411 0-8-3.589-8-8s3.589-8 8-8h1v7h7v1c0 4.411-3.589 8-8 8z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 32h4.917A6.017 6.017 0 0032 27.083V32zm7 2h-9v-9h1c4.411 0 8 3.589 8 8v1z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M37 16h6v-2h-6z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M43 34h18v-2H43zM43 38h18v-2H43zM43 42h18v-2H43z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M47 29h2v-2h-2zM51 29h2v-2h-2zM55 29h2v-2h-2zM8 70h64v-2H8z",
    className: "fi-icon-illustrative-base-fill"
  }))));
}

export default SvgIconIllustrationPresentation;